import {
  Box, SvgIcon, useTheme,
} from '@mui/material';
import { useLogo } from '../../../config/useLogo';
import { DashboardScreensLayoutProps } from '../DashboardLayout';
import { DashboardNavElement } from '../DashboardNavElement';

export interface DashboardSubMenuItemsProps {
  title: string;
  path: string;
  isCurrent?: boolean;
  onClick?: () => void;
  rightIcon?: typeof SvgIcon;
}

export function DashboardDesktopLayout({ children, navElems }: DashboardScreensLayoutProps) {
  const { secondaryOne: NavLogo } = useLogo();
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
      }}
    >
      {/* left nav */}
      <Box
        sx={{
          width: theme.spacing(34.375),
          height: '100vh',
          maxHeight: '100vh',
          overflowY: 'auto',
          position: 'sticky',
          top: theme.spacing(0),
          flexShrink: 0,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            paddingTop: theme.spacing(3),
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: theme.spacing(3),
            alignSelf: 'stretch',
          }}
        >
          {/* logo */}
          <Box
            sx={{
              display: 'flex',
              width: theme.spacing(24.375),
              alignItems: 'flex-start',
              marginLeft: theme.spacing(2),
            }}>
            {NavLogo && <img
              src={NavLogo as string}
              height={43}
              width={204}
              alt="Logo"
            />}
          </Box>
          <Box
            sx={{
              padding: `${theme.spacing(0)} ${theme.spacing(1.5)}`,
              alignSelf: 'stretch',
              display: 'flex',
              flexDirection: 'column',
              height: `calc(100vh - ${theme.spacing(12)})`,
            }}>
            <Box sx={{ flexGrow: 1 }}>
              {
                navElems.filter((elem) => !elem.bottomFixPosition).map((elem) => (
                  <DashboardNavElement
                    key={elem.name}
                    sx={{
                      // marginBottom: theme.spacing(1),
                      padding: theme.spacing(1.875),
                    }}
                    name={elem.name}
                    outlineIcon={elem.Outline}
                    filledIcon={elem.Filled}
                    path={elem.path}
                    isSelected={elem.isCurrent ?? false}
                    subMenuItems={elem.subMenuItems}
                    bottomFixPosition={elem.bottomFixPosition}
                    secondaryLabel={elem.secondaryLabel}
                    rightIcon={elem.rightIcon}
                    onSecondaryLabelClick={elem.onSecondaryLabelClick}
                    onClick={() => {
                      if (elem.onClick) elem.onClick();
                    }}
                  />
                ))
              }
            </Box>
            <Box>
              {
                navElems.filter((elem) => elem.bottomFixPosition).map((elem) => (
                  <DashboardNavElement
                    key={elem.name}
                    sx={{
                      // marginBottom: theme.spacing(1),
                      padding: theme.spacing(1.875),
                    }}
                    name={elem.name}
                    outlineIcon={elem.Outline}
                    filledIcon={elem.Filled}
                    path={elem.path}
                    isSelected={elem.isCurrent ?? false}
                    subMenuItems={elem.subMenuItems}
                    bottomFixPosition={elem.bottomFixPosition}
                    secondaryLabel={elem.secondaryLabel}
                    rightIcon={elem.rightIcon}
                    onSecondaryLabelClick={elem.onSecondaryLabelClick}
                    onClick={() => {
                      if (elem.onClick) elem.onClick();
                    }}
                  />
                ))
              }
            </Box>
          </Box>
        </Box>
      </Box>
      {/* end left nav */}

      {/* verticle divider */}
      <Box
        sx={{
          position: 'fixed',
          left: theme.spacing(34.375), // Match sidebar width
          top: 0,
          width: theme.spacing(0.125),
          height: '100vh',
          backgroundColor: theme.palette.grey[200],
          zIndex: 10,
        }}
      />
      {/* end verticle divider */}

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: '1 0 0',
        }}
      >
        {children}
      </Box >
    </Box >
  );
}
